/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {chooseOffer, fetchOffers} from '../../common/offers/actions';
import {getNameByLang} from '../../common/lib/util';

class ChooseOffer extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        offers: React.PropTypes.object,
        bar: React.PropTypes.object,
        fetchOffers: React.PropTypes.func,
        chooseOffer: React.PropTypes.func
    };

    componentWillMount() {
        const {fetchOffers, bar, chooseOffer} = this.props;
        fetchOffers(bar.get('id')).payload.promise
            .then(res => {
                if (!!res.data && res.data.length === 1) {
                    chooseOffer(res.data[0].id);
                }
            })
            .catch(() => console.error('ChooseOfferError'));
    }

    render() {
        const {chooseOffer, offers, msg} = this.props;

        return (
            <div id="login-page" className="pageNotification">
                <h1 className="pageNotification-logo">{msg.global.appName}</h1>
                <div className="pageNotification-content">
                    <h2 className="pageNotification-title">{msg.chooseOffer.title}</h2>
                        <div className="pageNotification-box">
                             {!!offers && offers.map(offer =>
                            <div className="pageNotification-box-row"
                                 onClick={() => chooseOffer(offer.get('id'))}
                                 key={`offer-${offer.get('id')}`}>
                                <div className="btn btn-greenLight btn-block">
                                    {getNameByLang(offer)}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    offers: state.offers.get('offers'),
    bar: state.bars.get('bar')
}), {fetchOffers, chooseOffer})(ChooseOffer);



// WEBPACK FOOTER //
// ./src/browser/login/ChooseOffer.js